(function () {
  'use strict';

  function initSubscribe(root) {
    if (root.dataset.qeshopSubscribeReady === 'true') return;

    var form = root.querySelector('[data-subscribe-form]');
    if (!form) return;

    root.dataset.qeshopSubscribeReady = 'true';

    var searchInput = form.querySelector('[data-subscribe-search]');
    var searchClear = form.querySelector('[data-subscribe-search-clear]');
    var searchResults = form.querySelector('[data-subscribe-search-results]');
    var searchStatus = form.querySelector('[data-subscribe-search-status]');
    var variantSelect = form.querySelector('[data-subscribe-variant-select]');
    var frequencyWrap = form.querySelector('[data-subscribe-frequency-wrap]');
    var frequencySelect = form.querySelector('[data-subscribe-frequency]');
    var planButtons = form.querySelectorAll('[data-subscribe-plan]');
    var subscribeButton = form.querySelector('[data-subscribe-plan="subscribe"]');
    var variantInput = form.querySelector('[data-subscribe-variant]');
    var sellingPlanInput = form.querySelector('[data-subscribe-selling-plan]');
    var image = form.querySelector('[data-subscribe-image]');
    var title = form.querySelector('[data-subscribe-title]');
    var meta = form.querySelector('[data-subscribe-meta]');
    var wasPrice = form.querySelector('[data-subscribe-was]');
    var currentPrice = form.querySelector('[data-subscribe-price]');
    var priceNote = form.querySelector('[data-subscribe-price-note]');
    var delivery = form.querySelector('[data-subscribe-delivery]');
    var deliveryNote = form.querySelector('[data-subscribe-delivery-note]');
    var save = form.querySelector('[data-subscribe-save]');
    var cta = form.querySelector('[data-subscribe-cta]');
    var note = form.querySelector('[data-subscribe-note]');

    var mode = 'subscribe';
    var currentProduct = null;
    var planNames = {};
    var catalog = null;
    var catalogPromise = null;
    var activeResult = -1;

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    }

    function imageUrl(url) {
      if (!url) return '';
      return url.indexOf('//') === 0 ? window.location.protocol + url : url;
    }

    function availableVariants() {
      if (!currentProduct) return [];
      return (currentProduct.variants || []).filter(function (variant) {
        return variant.available;
      });
    }

    function selectedVariant() {
      var variantId = String(variantSelect.value);
      return availableVariants().find(function (variant) {
        return String(variant.id) === variantId;
      }) || null;
    }

    function selectedAllocation(variant) {
      if (!variant) return null;
      var planId = String(frequencySelect.value || '');
      return (variant.selling_plan_allocations || []).find(function (allocation) {
        return String(allocation.selling_plan_id) === planId;
      }) || null;
    }

    function requiresPrescription(product) {
      var productType = String(product && (product.type || product.product_type) || '').toLowerCase();
      return productType.indexOf('contact lens') !== -1
        || productType.indexOf('disposable') !== -1
        || productType.indexOf('toric') !== -1;
    }

    function closeResults() {
      searchResults.hidden = true;
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.removeAttribute('aria-activedescendant');
      activeResult = -1;
    }

    function sync() {
      if (!currentProduct) return;

      var variant = selectedVariant();
      if (!variant) return;

      var allocations = variant.selling_plan_allocations || [];
      var canSubscribe = allocations.length > 0;
      var allocation = selectedAllocation(variant) || allocations[0] || null;

      if (mode === 'subscribe' && !canSubscribe) mode = 'once';

      planButtons.forEach(function (button) {
        var active = button.dataset.subscribePlan === mode;
        button.classList.toggle('on', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      subscribeButton.disabled = !canSubscribe;
      frequencyWrap.hidden = mode !== 'subscribe' || !canSubscribe;
      variantInput.value = variant.id;
      sellingPlanInput.value = allocation ? allocation.selling_plan_id : '';
      sellingPlanInput.disabled = mode !== 'subscribe' || !allocation;

      image.src = imageUrl(currentProduct.featured_image);
      image.alt = currentProduct.title;
      title.textContent = currentProduct.title;
      meta.textContent = (currentProduct.type || 'Contact lenses') + ' \u00b7 ' + variant.title;

      var subscribed = mode === 'subscribe' && Boolean(allocation);
      var subscriptionPrice = subscribed ? allocation.price : variant.price;
      var discount = subscribed && variant.price
        ? Math.max(0, Math.round((1 - Number(allocation.price) / Number(variant.price)) * 100))
        : 0;

      wasPrice.hidden = !subscribed;
      wasPrice.textContent = formatMoney(variant.price);
      currentPrice.textContent = formatMoney(subscriptionPrice);
      priceNote.hidden = !subscribed;
      priceNote.textContent = subscribed ? 'delivery calculated at checkout' : '';

      delivery.textContent = subscribed
        ? (planNames[String(allocation.selling_plan_id)] || 'Subscription delivery')
        : 'Delivered once | standard delivery';
      deliveryNote.textContent = subscribed
        ? 'Optician re-check before each dispatch'
        : 'Reorder manually when you need to';
      save.hidden = !subscribed || discount <= 0;
      save.textContent = discount > 0 ? 'Save ' + discount + '%' : '';
      cta.textContent = requiresPrescription(currentProduct)
        ? 'Choose prescription'
        : (subscribed ? 'Start subscription' : 'Add one-off to basket');
      note.textContent = subscribed
        ? 'Cancel after your second billing cycle | First box ships now'
        : 'Switch to subscribe and save on every reorder';
    }

    function populateFrequencies(variant, preferredPlanId) {
      frequencySelect.replaceChildren();

      (variant.selling_plan_allocations || []).forEach(function (allocation) {
        var option = document.createElement('option');
        option.value = allocation.selling_plan_id;
        option.textContent = planNames[String(allocation.selling_plan_id)] || 'Subscription delivery';
        if (String(allocation.selling_plan_id) === String(preferredPlanId || '')) option.selected = true;
        frequencySelect.appendChild(option);
      });
    }

    function populateVariants(product, preferredVariantId) {
      currentProduct = product;
      planNames = {};

      (product.selling_plan_groups || []).forEach(function (group) {
        (group.selling_plans || []).forEach(function (plan) {
          planNames[String(plan.id)] = plan.name;
        });
      });

      variantSelect.replaceChildren();
      availableVariants().forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        if (String(variant.id) === String(preferredVariantId || '')) option.selected = true;
        variantSelect.appendChild(option);
      });

      var variant = selectedVariant();
      if (variant) populateFrequencies(variant);
      sync();
    }

    function loadProduct(handle, preferredVariantId) {
      searchStatus.textContent = 'Loading ' + handle.replace(/-/g, ' ') + '...';
      form.setAttribute('aria-busy', 'true');

      return fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product request failed');
          return response.json();
        })
        .then(function (product) {
          populateVariants(product, preferredVariantId);
          searchInput.value = product.title;
          closeResults();

          var hasSubscription = availableVariants().some(function (variant) {
            return (variant.selling_plan_allocations || []).length > 0;
          });
          searchStatus.textContent = hasSubscription
            ? 'Selected. Choose a pack size and delivery frequency.'
            : 'Selected. This product currently supports one-off orders only.';
        })
        .catch(function () {
          searchStatus.textContent = 'This product could not be loaded. Please try another search.';
        })
        .finally(function () {
          form.removeAttribute('aria-busy');
        });
    }

    function loadCatalog() {
      if (catalog) return Promise.resolve(catalog);
      if (catalogPromise) return catalogPromise;

      catalogPromise = fetch(root.dataset.productsUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Catalogue request failed');
          return response.json();
        })
        .then(function (payload) {
          catalog = (payload.products || [])
            .filter(function (product) {
              return (product.variants || []).some(function (variant) {
                return variant.available;
              });
            })
            .sort(function (a, b) {
              return a.title.localeCompare(b.title);
            });
          return catalog;
        })
        .catch(function () {
          catalogPromise = null;
          searchStatus.textContent = 'The lens catalogue could not be loaded. Please try again.';
          throw new Error('Catalogue request failed');
        });

      return catalogPromise;
    }

    function resultButtons() {
      return Array.from(searchResults.querySelectorAll('[data-subscribe-search-option]'));
    }

    function setActiveResult(index) {
      var buttons = resultButtons();
      if (!buttons.length) return;

      activeResult = Math.max(0, Math.min(index, buttons.length - 1));
      buttons.forEach(function (button, buttonIndex) {
        button.classList.toggle('is-active', buttonIndex === activeResult);
      });
      searchInput.setAttribute('aria-activedescendant', buttons[activeResult].id);
    }

    function renderResults(products, query) {
      searchResults.replaceChildren();
      activeResult = -1;

      if (!products.length) {
        var empty = document.createElement('span');
        empty.textContent = 'No available lenses match "' + query + '".';
        searchResults.appendChild(empty);
      } else {
        products.forEach(function (product, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.id = 'subscribe-lens-option-' + index;
          button.className = 'subscribe__search-result';
          button.setAttribute('role', 'option');
          button.dataset.subscribeSearchOption = product.handle;

          if (product.images && product.images[0]) {
            var resultImage = document.createElement('img');
            resultImage.src = imageUrl(product.images[0].src);
            resultImage.alt = '';
            resultImage.loading = 'lazy';
            button.appendChild(resultImage);
          }

          var copy = document.createElement('span');
          var name = document.createElement('strong');
          var vendor = document.createElement('small');
          name.textContent = product.title;
          vendor.textContent = product.vendor || product.product_type || 'Contact lenses';
          copy.append(name, vendor);
          button.appendChild(copy);
          button.addEventListener('mousedown', function (event) {
            event.preventDefault();
          });
          button.addEventListener('click', function () {
            loadProduct(product.handle);
          });
          searchResults.appendChild(button);
        });
      }

      searchResults.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      searchStatus.textContent = products.length
        ? 'Showing ' + products.length + ' matching lenses.'
        : 'No matching available lenses.';
    }

    function searchCatalog() {
      var query = searchInput.value.trim().toLowerCase();
      searchStatus.textContent = 'Searching current products...';

      loadCatalog()
        .then(function (products) {
          var matches = products.filter(function (product) {
            if (!query) return true;
            return (product.title + ' ' + product.vendor).toLowerCase().indexOf(query) !== -1;
          }).slice(0, 8);
          renderResults(matches, query);
        })
        .catch(function () {
          searchResults.hidden = true;
          searchInput.setAttribute('aria-expanded', 'false');
        });
    }

    form.addEventListener('submit', function (event) {
      if (!currentProduct || !requiresPrescription(currentProduct)) return;

      var variant = selectedVariant();
      if (!variant) return;

      event.preventDefault();
      var destination = new URL('/products/' + currentProduct.handle, window.location.origin);
      var allocation = selectedAllocation(variant);
      destination.searchParams.set('purchase', mode === 'subscribe' && allocation ? 'subscription' : 'once');
      destination.searchParams.set('variant', variant.id);
      if (mode === 'subscribe' && allocation) {
        destination.searchParams.set('selling_plan', allocation.selling_plan_id);
      }
      window.location.assign(destination.pathname + destination.search);
    });

    planButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        mode = button.dataset.subscribePlan;
        sync();
      });
    });

    variantSelect.addEventListener('change', function () {
      var variant = selectedVariant();
      if (variant) populateFrequencies(variant);
      sync();
    });
    frequencySelect.addEventListener('change', sync);
    searchInput.addEventListener('focus', searchCatalog);
    searchInput.addEventListener('input', searchCatalog);
    searchInput.addEventListener('keydown', function (event) {
      var buttons = resultButtons();
      if (event.key === 'ArrowDown' && buttons.length) {
        event.preventDefault();
        setActiveResult(activeResult + 1);
      } else if (event.key === 'ArrowUp' && buttons.length) {
        event.preventDefault();
        setActiveResult(activeResult <= 0 ? buttons.length - 1 : activeResult - 1);
      } else if (event.key === 'Enter' && activeResult >= 0 && buttons[activeResult]) {
        event.preventDefault();
        buttons[activeResult].click();
      } else if (event.key === 'Escape') {
        closeResults();
      }
    });
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchInput.focus();
      searchCatalog();
    });
    document.addEventListener('click', function (event) {
      if (!form.contains(event.target)) closeResults();
    });

    fetch(root.dataset.initialProductUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Initial product request failed');
        return response.json();
      })
      .then(function (product) {
        populateVariants(product, variantInput.value);
      })
      .catch(function () {
        searchStatus.textContent = 'Search for a lens to update this subscription.';
      });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-qeshop-subscribe]').forEach(initSubscribe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
